jQuery(function ($) {

    $(window).load(function() {
        $("html").removeClass("no-js"); // removes no-js class when js executes
        $("body").removeClass("preload"); // prevents flash of un-transitioned elements with css transitions
        $("#wrapper").removeClass("load-with-js"); // prevents flash of unstyled content and provides a fade on load effect with css
		equalHeight();
		respSquare();
        $(".off-canvas a, .off-canvas input, .off-canvas button, a.post-featured-image").attr("tabindex", "-1");
        $("#scrollheader").find("a").each(function() {
            $(this).attr('tabindex', "-1");
        });
    });

	$(document).ready(function() {
		/*****REMOVE PARENT P TAG FROM CTA CLASS*****/
		var cta = $(".cta");
		if ( cta.parent().is( "p" ) ) {
			cta.unwrap();
		}
	});

    /***** DRILLDOWN MENU HEIGHT *****/
//     var menu = $(".is-drilldown-submenu");
//     var menuheight = $(".is-drilldown").outerHeight();
//     var observer = new MutationObserver(function(mutations) {
//       mutations.forEach(function(mutation) {
//         if (mutation.attributeName === "class") {
//           var attributeValue = $(mutation.target).prop(mutation.attributeName);
//           if (attributeValue.indexOf(" is-active") >= 0) {
//             var submenuheight = 0;
//             $(mutation.target).children().each(function(){
//                 submenuheight = submenuheight + $(this).outerHeight(true);
//             });
//             if( menuheight < submenuheight) {
//                 $(".is-drilldown").outerHeight(submenuheight);
//             }
//           }
//           else {
//             $(".is-drilldown").outerHeight(menuheight);
//           }
//         }
//       });
//     });
//     observer.observe(menu[0], {
//       attributes: true
//     });

    $("#megamenu .menu-item").on("hover", function() {
        $("#header").addClass("hover");
    });
    $("main").on("hover", function() {
        $("#header").removeClass("hover");
    });

    /***** SEARCH Toggle *****/
    $("#search_tog, #search_tog2").on("click", function() {
        $("#livesearch").addClass("open");
        $("#search-field").focus();
    });
    $("#search_close").on("click", function() {
        $("#livesearch").removeClass("open");
    });


	/***** RESPONSIVE SQUARE/CIRCLE SCRIPT *****/
	function respSquare() {
		$('.circle').each(function() {
			var cirwidth = $(this).width();
			$(this).height(cirwidth);
		});
		$('.square').each(function() {
			var cirwidth = $(this).width();
			$(this).height(cirwidth);
		});
	}

    /***** EQUAL HEIGHT ELEMENTS *****/
    //add .equalheight class to items needing to be the same height
	function equalHeight() {
		window.windowWidth = $(window).width();
		$('.equalheight-parent').each(function(){
			if (Foundation.MediaQuery.atLeast('mid') ){
				var hi = 0;
				var i = 1;
				$(this).find('.equalheight').css('height', '').each(function(){
                    var h = $(this).outerHeight();
					var mh = $(this).css("min-height").replace(/[^-\d\.]/g, '');
					var ch = $(this).find(".tech-data").outerHeight();
					//var vh = $(this).find(".flexi_vid").outerHeight();

					//if(vh > h || vh > ch || vh > mh) { h = vh; }
					if(ch > h || ch > mh) { h = ch; }
					//if(mh > h || mh > ch || mh > vh){ h = mh; }
					if(mh > h) {
						h = mh; // if min-height value is greater than the outerheight value, replace "h" variable value
					}
					if(h > hi){
					   hi = h; // if height is the highest, save to "hi" variable
					}
					i++;
				});
				$(this).find(".equalheight, .menu-item").css('height', hi); //set all to highest variable value
			}
			else {
				$(this).find('.equalheight, .menu-item').css("height", "auto");
			}
		});
        $('.sub-nav').each(function(){
			if (Foundation.MediaQuery.atLeast('mid') ){
				var hi = 0;
				var i = 1;
				$(this).find('.menu-item').css('height', '').each(function(){
                    var h = $(this).outerHeight();
					var mh = $(this).css("min-height").replace(/[^-\d\.]/g, '');
					if(mh > h) {
						h = mh; // if min-height value is greater than the outerheight value, replace "h" variable value
					}
					if(h > hi){
					   hi = h; // if height is the highest, save to "hi" variable
					}
					i++;
				});
				$(this).find(".equalheight, .menu-item").css('height', hi); //set all to highest variable value
			}
			else {
				$(this).find('.equalheight, .menu-item').css("height", "auto");
			}
		});
	}

    function equalMenu() {
		window.windowWidth = $(window).width();
        $('.sub-nav').each(function(){
			if (Foundation.MediaQuery.atLeast('mid') ){
				var hi = 0;
				var i = 1;
				$(this).find('.menu-item').css('height', '').each(function(){
                    var h = $(this).outerHeight();
					var mh = $(this).css("min-height").replace(/[^-\d\.]/g, '');
					if(mh > h) {
						h = mh; // if min-height value is greater than the outerheight value, replace "h" variable value
					}
					if(h > hi){
					   hi = h; // if height is the highest, save to "hi" variable
					}
					i++;
				});
				$(this).find(".menu-item").css('height', hi); //set all to highest variable value
			}
			else {
				$(this).find('.menu-item').css("height", "auto");
			}
		});
	}

	var page_header_content_position = $("#header_text").position();
	var page_footer_content_position = $("#footer_text").position();

    /***** MAKE PAGE HEADER & FOOTER HAVE A MIN-HEIGHT of the CONTENT HEIGHT WITHIN *****/
    function adaptPageElementsOnResizeAndReady() {

		// Page Header Min-Height
		var page_header = $("#page_header .row");
        var page_header_text = $("#header_text");
        var page_header_content_height = parseInt(page_header_text.innerHeight());
        var page_header_content_top = 0;
		var row_padding_top = parseInt(page_header.css("padding-top"));
		var row_padding_bottom = parseInt(page_header.css("padding-bottom"));
		var page_header_content_margintop = parseInt($("#header_text").css("margin-top"));

		if (Foundation.MediaQuery.atLeast('medium') && document.getElementById("page_header")) {
            if (page_header_content_position) { page_header_content_top = page_header_content_position.top; }
            page_header_content_top = page_header_content_margintop+page_header_content_top+row_padding_top+row_padding_bottom;
        }
		if(page_header_content_top > "0") {
			page_header_min_height = page_header_content_top + page_header_content_height + 'px';
		}
        else {
			page_header_min_height = page_header_content_height + 'px';
		}
		page_header.css("min-height", page_header_min_height);


		// Page Footer Min-Height
		var page_footer = $("#page_footer .row");
        var page_footer_text = $("#footer_text");
        var page_footer_content_height = parseInt(page_footer_text.innerHeight());
        var page_footer_content_top = 0;
		var frow_padding_top = parseInt(page_footer.css("padding-top"));
		var frow_padding_bottom = parseInt(page_footer.css("padding-bottom"));
		var page_footer_content_margintop = parseInt($("#footer_text").css("margin-top"));

        if (Foundation.MediaQuery.atLeast('medium') && document.getElementById("page_footer")) {
            if (page_footer_content_position) { page_footer_content_top = page_footer_content_position.top; }
            page_footer_content_top = page_footer_content_margintop+page_footer_content_top+frow_padding_top+frow_padding_bottom;
        }
		if(page_footer_content_top > "0") { page_footer_min_height = page_footer_content_top + page_footer_content_height + 'px'; }
        else { page_footer_min_height = page_footer_content_height + 'px'; }
        page_footer.css("min-height", page_footer_min_height);
        $("#page_footer").css("min-height", page_footer_min_height);

        // Make elements equal height on resize
        equalHeight();

        // Square
        respSquare();

        // Responsive Tabindex

        if ($(".hide-for-large").css("display") == "none") {
            $(".hide-for-large").children().find("a").attr("tabindex", "-1");
        }
        else {
            $(".hide-for-large").children().find("a").attr("tabindex", "0");
        }

        if ($(".hide-for-small").css("display") == "none") {
            $(".hide-for-small").children().find("a").attr("tabindex", "-1");
        }
        else {
            $(".hide-for-small").children().find("a").attr("tabindex", "0");
        }

        var menu = $(".off-canvas");
        var observer = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.attributeName === "class") {
              var attributeValue = $(mutation.target).prop(mutation.attributeName);
              if (attributeValue.indexOf(" is-open") >= 0) {
                $(mutation.target).children().find("a, input, button").attr("tabindex", "0");
              }
              else {
                $(mutation.target).children().find("a, input, button").attr("tabindex", "-1");
              }
            }
          });
        });
        observer.observe(menu[0], {
          attributes: true
        });

        var parent_width;
        if ($(".type-staff").css("margin-left") == "1px") {
            parent_width =  400;
            $(".staff-data").css("width", parent_width);
        }
        else {
            parent_width =  $(".page-template-template-staff .archive-grid, .tax-staff_cat .archive-grid, .tax-industry .archive-grid, .single-products .archive-grid, .single-species .archive-grid, .single-locations .archive-grid").width();
            $(".staff-data").css("width", parent_width-(parent_width*0.04));
        }

	}
	$(document).on("ready", adaptPageElementsOnResizeAndReady);
	$(window).on("resize", adaptPageElementsOnResizeAndReady);

    // For Gravity Forms Radio Button / Checkbox focus styles
    $(".gform_wrapper input[type='checkbox'], .gform_wrapper input[type='radio']").on("focus", function() {
        $(this).parent().addClass("focused");
    }).on("blur", function() {
        $(this).parent().removeClass("focused");
    });

    $(".staff-data").removeClass("show");

    $( ".columns.type-staff" ).on("click",
        function() {
            if ($(this).hasClass("open")) {
                $(this).find(".staff-data").removeClass("show");
                $(this).removeClass("open");
            }
            else {
                $(".staff-data").removeClass("show");
                $(this).find(".staff-data").addClass("show");
                $(this).addClass("open");
            }
        }
    );

    $("#event-archive .entry-content").removeClass("show");

    $( "#event-archive .event .fas").on("click",
        function() {
            $(this).parent().parent().parent().find(".entry-content").toggleClass("show");
            $(this).parent().find(".fas").toggleClass("show");
        }
    );

    $('.dynamic_select').on('change', function () {
          var url = $(this).val(); // get selected value
          if (url) { // require a URL
              window.location = url; // redirect
          }
          return false;
      });

    /***** ADD SCREENREADER TEXT TO target="_blank" LINKS *****/
    $('a').each(function() {

        var link = $(this);
        var linkText = $(this).text();

        if (!link.attr('href')) {
            return; // if href if not set
        }

        if (link.attr('aria-label')) {
            return; // if a custom aria label is already set
        }

        if ( link.attr('target') == '_blank' ) {
            // add aria label set to the original link text + append translatable external link message (set in footer.php)
            link.attr('aria-label', linkText + ', ' + ENV_VARS.extLinkMessage);
        }

        if ( link.hasClass('scrollto')) {
            // add aria label set to the original link text + append translatable scroll to link message (set in footer.php)
            link.attr('aria-label', linkText + ', ' + ENV_VARS.scrollToLinkMessage);
        }

    });

    /***** SIDEBAR SKIP TO LINK HREF *****/
    // Find any sidebars that are loaded before #inner-content + update their skip link href to  #inner-content
    $('#inner-content').prev('#sidebar').prev('.skip-link').attr('href', '#inner-content');

    /***** STATIC HEADER ON SCROLL *****/
    if ($("#scrollheader").length) {
        var $env_header_ht = $("#header").css("height");
        $env_header_ht = parseInt($env_header_ht);
        $(window).scroll(function() {
            var $envfromtop = $(this).scrollTop();
            if ($envfromtop > 0) {
                $("#scrollheader").css("display", "block");
                equalMenu();
            }
            else { $("#scrollheader").css("display", "none"); }
            if ($envfromtop >= 100) {
                $("#scrollheader").addClass("scrolled");
            }
            else { $("#scrollheader").removeClass("scrolled"); }
        });
    }

    $('a.scrollto').click(function() {
        if (location.pathname.replace(/^\//,'') === this.pathname.replace(/^\//,'') && location.hostname === this.hostname && !$(this).parent().hasClass('is-accordion-submenu-parent')) {
          var target = $(this.hash);
          if (target.length) {
            $('html, body').animate({
              scrollTop: target.offset().top
            }, 1000);
            return false;
          }
        }
    });

    /***** FADE IN ON SCROLL with CLASS *****/
    $(".fadein").css("opacity", 0);
    $(window).scroll(function() {
        var windowBottom = $(this).scrollTop() + $(this).innerHeight();
        $(".fadein").each(function() {
          /* Check the location of each desired element */
          var objectBottom = $(this).offset().top + $(this).outerHeight();
          /* If the element is completely within bounds of the window, fade it in */
          if (objectBottom < windowBottom) { //object comes into view (scrolling down)
            if ($(this).css("opacity")==="0") { $(this).fadeTo(500,1); }
          } else { //object goes out of view (scrolling up)
            if ($(this).css("opacity")==="1") { $(this).fadeTo(500,0); }
          }
        });
    }).scroll(); //invoke scroll-handler on page-load



	/***** RESPONSIVE TABLES *****/
    // based on http://www.jerrylow.com/basictable/demo/

    $(document).ready(function() {
        $('table').basictable({
            breakpoint: 740,
        });
    });



    /***** HAVE CLASS? *****/
    function hasClass(element, cls) {
        return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
    }

    /***** GO TO CATEGORY ARCHIVE BASED ON SELECT *****/
    var siteurl = ENV_VARS.siteurl;
	var postpage = ENV_VARS.postpage;
	var resourcepage = ENV_VARS.resourcepage;
	var staffpage = ENV_VARS.staffpage;
    var dropdown = document.getElementById("cat_select");
    var cat_slug = 'category';
	var page_slug = "?p="+postpage;
    if (dropdown) {
        if (hasClass(dropdown, 'resource_cat')) { cat_slug = "resource-category"; page_slug = "?p="+resourcepage; }
        if (hasClass(dropdown, 'staff_cat')) { cat_slug = "staff-category"; page_slug = "?p="+staffpage; }
        var onCatChange = function () {
            if ( dropdown.options[dropdown.selectedIndex].value ) {
				if ( dropdown.options[dropdown.selectedIndex].value === "all" ) {
					location.href = siteurl+"/"+page_slug;
				}
                else { location.href = siteurl+"/"+cat_slug+"/"+dropdown.options[dropdown.selectedIndex].value; }
            }
        };
        dropdown.onchange = onCatChange;
    }

/***** ADOBE ACCESSIBLE MEGA MENU*****/
    // initialize a selector as an accessibleMegaMenu
    $("#megamenu, #megamenu2").accessibleMegaMenu({
        /* prefix for generated unique id attributes, which are required
           to indicate aria-owns, aria-controls and aria-labelledby */
        uuidPrefix: "accessible-megamenu",

        /* css class used to define the megamenu styling */
        menuClass: "nav-menu",

        /* css class for a top-level navigation item in the megamenu */
        topNavItemClass: "nav-item",

        /* css class for a megamenu panel */
        panelClass: "sub-nav",

        /* css class for a group of items within a megamenu panel */
        panelGroupClass: "sub-nav-group",

        /* css class for the hover state */
        hoverClass: "hover",

        /* css class for the focus state */
        focusClass: "focus",

        /* css class for the open state */
        openClass: "open"
    });

    /*Add Top Level Menu Name to current open mega menu
    $("#megamenu>ul>li.menu-item-has-children").each(  function() {
        var menuTitle = $(this).find('a').first().text();
        var menu = $(this).find('ul.sub-nav').first();
        menu.prepend($('<li class="mega-menu-title">'+menuTitle+'</li>'));
    });*/

    // Affix megamenu to bottom edge of #header
    var mainHeaderHeight = $("#header").outerHeight();
    $('#megamenu .sub-nav').css("top", mainHeaderHeight);

    // Create Sticky Header
    var stickyHeader = $('#top-bar-menu');
    var stickyHeaderTop = $(stickyHeader).offset().top;

    $(window).scroll(function(){

        if( $(window).scrollTop() > stickyHeaderTop ) {
            stickyHeader.addClass('sticky-header');
            $('#megamenu .sub-nav').removeClass('open');

            setTimeout(
              function()
              {
                var stickyHeaderHeight = stickyHeader.outerHeight();
                $('#megamenu .sub-nav').css("top", stickyHeaderHeight);
              }, 500);


        } else {
            stickyHeader.removeClass('sticky-header');

            setTimeout(
              function()
              {
                $('#megamenu .sub-nav').css("top", mainHeaderHeight);
              }, 500);
        }
    });

    //For Mega Menu Parent items - prevent #hash default click behavior
    $("#megamenu li.menu-item-has-children.nav-item>a").on( "click", function(e) {
        e.preventDefault();
    });


    // For sub-nav items acting as a section heading (not a link)
    if (Foundation.MediaQuery.atLeast('large') ){
        $(".sub-nav-title>a").on( "click", function(e) {
            e.preventDefault();
        });
    }

    function truncate(string, len){
        if (string.length > len) {

            //trim the string to the maximum length
            var trimmedString = string.substr(0, len);

            //re-trim if we are in the middle of a word
            trimmedString = trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(" ")));

            return trimmedString;

        }
        else
           return string;
    }

    $(".image_info .description").each(function() {
        var icap_trunc = $(this).html();
        icap_trunc = truncate(icap_trunc, 120);
        $(this).html(icap_trunc);
    });




    // Enable Image Modal Slider (supports filtered gallery)

    $(document).on( 'click', '.image-modal-controls .nav', function(event){

        //ignore default click behavior (prevents page scroll)
        event.preventDefault();

        // Locate thumbnail that triggered modal
        var modID = $(this).parents('.reveal').attr('id');
        var currentThumbnail = $('[data-open="'+modID+'"]').parent();

        // Prev link
        if($(this).hasClass('prev')){

            var prevFilteredImageLink = currentThumbnail.prevAll('.inf-post:visible').first().find('a');
            if(prevFilteredImageLink.length){
                prevFilteredImageLink.focus().click();
            } else{
                //wrap around to end
                $('.inf-post:visible').last().find('a').focus().click();
            }

        // Next Link
        } else {

            var nextFilteredImageLink = currentThumbnail.nextAll('.inf-post:visible').first().find('a');
            if(nextFilteredImageLink.length){
                nextFilteredImageLink.focus().click();
            } else {
                //wrap around to beginning
                $('.inf-post:visible').first().find('a').focus().click();
            }
        }
    });

});